export interface Accumulator {
  data: Record<string, unknown>[]
  included: Record<string, unknown>[]
  meta: Record<string, unknown>
  links: Record<string, unknown>
}

export interface WalkRequest extends GetRequest {
  acc?: Accumulator
}

export interface GenericRequest {
  headers?: Record<string, string>
  url: string
}

export interface GetRequest extends GenericRequest {
  data: {
    filter?: string
    fields: Record<string, string[]>
    where?: Record<string, string | number | (string | number)[]>
    include?: string[]
    order?: string
    perPage?: number
    offset?: number
    walk?: boolean
  } & Record<string, unknown>
}

export interface Relationship {
  data: {
    type: string
    id: string
  }
}

export type Relationships = Record<string, Relationship | Relationship[]>
export interface PostRequest extends GenericRequest {
  data?: {
    fields?: Record<string, string> // value should be comma separated string
    include?: string[]
    data?: {
      type: string
      attributes: Record<string, unknown>
      relationships?: Relationships
    }
  }
}

export type PatchRequest = PostRequest

export interface DeleteRequest extends GenericRequest {}

export interface ApiClient<T = unknown> {
  get(_request: GetRequest): Promise<T>
  post(_request: PostRequest): Promise<T>
  patch(_request: PatchRequest): Promise<T>
  delete(_request: DeleteRequest): Promise<T>
}

export type RequestData = {
  fields: Record<string, string[] | string>
  where: Record<string, string | number | (string | number)[]>
  include: string[]
  data: Record<string, unknown>
  perPage: number
  offset: number
  order: string
}
